<template>
  <div>
    <Row>
      <i-col span="22"></i-col>
      <i-col span="2">
        <Button type="primary" @click="add" v-if="privilegesbtn('/company/create')">新增</Button>
      </i-col>
    </Row>
    <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          :total="total"
          :current="page"
          @on-change="changePage"
          :page-size="pagesize"
          show-total
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import { companylist, deletecompany } from "../../api/companyapi";
import constantdata from "../../constant/index";
import privilegesbtn from "../../constant/privilegesbtn.js";
import openpage from "../../constant/openpage.js";
export default {
  data() {
    return {
      self: this,
      tableData: [],
      total: 0,
      page: 1,
      pagesize: 10,
      isupdte: privilegesbtn("/company/update"),
      isdelete: privilegesbtn("/company/delete"),
      isadminlist: privilegesbtn("/company_admin/index"),
      isservice: privilegesbtn("/company/service_index"),
      formInline: {
        keywords: ""
      },
      tableColumns: [
        {
          title: "集团名称",
          key: "name",
          align: "center"
        },
        {
          title: "集团类型",
          key: "type",

          align: "center",
          render: (h, params) => {
            var data = constantdata.companytype.filter(item => {
              return item.type == params.row.type;
            });
            if (data.length == 1) {
              return h("span", data[0].value);
            } else {
              return h("span", "--");
            }
          }
        },
        {
          title: "审核情况",
          align: "center",

          key: "examine",
          render: (h, params) => {
            var examine = params.row.examine == 0 ? "未通过" : "通过";
            return h("span", examine);
          }
        },
        {
          title: "佣金比例",
          align: "center",
          key: "union_distribution_rate",
            render: (h, params) => {
            var union_distribution_rate = params.row.union_distribution_rate*100+'%';
            return h("span", union_distribution_rate);
          }
        },
        {
          title: "创建时间",
          align: "center",
          key: "createtime"
        },
        {
          title: "操作",
          key: "action",
          width: 300,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: !this.isupdte
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: !this.isadminlist
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.adminlist(params.row.id, params.row.name);
                    }
                  }
                },
                "管理员列表"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: !this.isservice
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.servicelist(params.row.id, params.row.name);
                    }
                  }
                },
                "服务列表"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    disabled: !this.isdelete
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  methods: {
    privilegesbtn: privilegesbtn,
    mockTableData() {
      let para = {
        page: this.page,
        pagesize: this.pagesize
      };
      this.$Loading.start();
      companylist(para).then(res => {
        this.$Loading.finish();
        var Data = res.data;
        this.total = Data.data.total;
        this.tableData = Data.data.data;
      });
    },
    // adminlock(param) {
    //   let para = {
    //     id: param.id
    //   };
    //   this.$Loading.start();
    //   lockadmin(para).then(res => {
    //     this.$Loading.finish();
    //     debugger;
    //     var data = res.data;
    //     if (data.code == 1) {
    //       this.$Message.success(data.message);
    //     } else {
    //       this.changePage(this.page);
    //       this.$Message.error(data.message);
    //     }
    //   });
    // },
    show(param) {
      this.$router.push({ path: "/companyupdte", query: param });
    },
    add() {
      this.$router.push({ path: "/companyadd" });
    },
    adminlist(id, name) {
      var query = { id: id, name: name };
      openpage("companyadmin", query);
      //this.$router.push({ path: "/companyadmin", query: {id:param} });
    },
    servicelist(id, name) {
      var query = { id: id, name: name };
      openpage("servicelist", query);
    },
    remove(index) {
      let self = this;
      this.$Modal.confirm({
        title: "集团列表",
        content: `是否删除此记录`,
        onOk: function() {
          this.$Loading.start();
          let para = { id: index };
          deletecompany(para).then(res => {
            let data = res.data;
            if (data.code == 1) {
              self.$Message.success(data.message);
              self.changePage(self.page);
            } else {
              self.$Message.error(data.message);
            }
          });
        }
      });
    },
    changePage(row) {
      this.page = row;
      this.mockTableData();
    }
  },
  mounted() {
    this.mockTableData();
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/company/index.vue